import React from 'react'
import { NumericFormat } from 'react-number-format'

export default React.forwardRef(function NumberFormat(props, ref) {
  const { onChange, ...other } = props

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      allowNegative={false}
      allowLeadingZeros={true}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        })
      }}
    />
  )
})
